import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Paginations from "../../../components/paginaton/Paginations";

const ShippingDelivery = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [shipmentTypes, setShipmentTypes] = useState([]);
  const [allDeliveries, setAllDeliveries] = useState([]);
  const [allWaiters, setAllWaiters] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [totalPagesWaiter, setTotalPagesWaiter] = useState("");
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [showWaiterModal, setShowWaiterModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    cashDeskId: 0,
    saleUnitId: 0,
    orderNumber: 0,
    categoryId: 0,
    orderType: 0,
    posDeviceId: 0,
    size: 20,
    part: 1,
    invoiceNumber: "",
    merchantName: "",
    merchantPhone: "",
    merchantCode: "",
    destination: "",
    paymentType: 0,
    orderStatus: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    endDate: "",
    total: 0,
    parts: 0,
  });
  const [deliverToDeriverModel, setDeliverToDeriverModel] = useState({
    invoiceId: 0,
    // deliveryUserId: 0
    deliveryUserId: "",
  });

  const [deliveryOrderToDriverBulkyModel, setDeliveryOrderToDriverBulkyModel] =
    useState({
      invoiceIds: [],
      deliveryUserId: "",
    });
  const [groupSelection, setGroupSelection] = useState(false);
  const [deliverToWaiterModel, setDeliverToWaiterModel] = useState({
    invoiceId: 0,
    // waiterUserId: 0
    waiterUserId: "",
  });
  const [deliveriesFilterModel, setDeliveriesFilterModel] = useState({
    branchId: branchId,
    firstName: "",
    lastName: "",
    mobile: 0,
    code: 0,
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });

  const [waitersFilterModel, setWaitersFilterModel] = useState({
    branchId: branchId,
    firstName: "",
    lastName: "",
    mobile: "",
    code: 0,
    // size: 20,
    // part: 1,
    // total: 0,
    // parts: 0
  });

  const getShipmentTypes = async () => {
    const resp = await apiMethod.getShipmentTypes();
    if (!methods.showApiErrors(resp)) return false;
    setShipmentTypes(resp.data);
  };

  const getOrderTypes = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);
  };

  const getGridData = async () => {
    const cookedResp = await apiMethod.getCoockedOrders(
      branchId,
      filterModel.orderNumber,
      filterModel.saleUnitId,
      filterModel.cashDeskId,
      filterModel.posDeviceId,
      filterModel.invoiceNumber,
      filterModel.merchantName,
      filterModel.merchantPhone,
      filterModel.merchantCode,
      filterModel.destination,
      filterModel.orderType,
      filterModel.paymentType,
      filterModel.orderStatus,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.part,
      filterModel.size
    );
    if (methods.showApiErrors(cookedResp)) {
      filterModel.total = cookedResp.total;
      filterModel.parts = methods.calcPageParts(
        cookedResp.total,
        filterModel.size
      );
      setGridData(cookedResp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      createConnection();
      await getShipmentTypes();
      await getBaseInfo();
      await getOrderTypes();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const getAllDeliveries = async () => {
    const resp = await apiMethod.getDeliveries(
      deliveriesFilterModel.branchId,
      deliveriesFilterModel.size,
      deliveriesFilterModel.part,
      deliveriesFilterModel.firstName,
      deliveriesFilterModel.lastName,
      deliveriesFilterModel.mobile,
      deliveriesFilterModel.code
    );
    if (methods.showApiErrors(resp)) {
      deliveriesFilterModel.total = resp.total;
      deliveriesFilterModel.parts = methods.calcPageParts(
        resp.total,
        deliveriesFilterModel.size
      );
      setTotalPagesWaiter(resp.total);
      setDeliveriesFilterModel({ ...deliveriesFilterModel });
      setAllDeliveries(resp.data);
    }
  };

  const getAllWaiters = async () => {
    const resp = await apiMethod.getWaiters(
      waitersFilterModel.branchId,
      waitersFilterModel.mobile,
      waitersFilterModel.firstName,
      waitersFilterModel.lastName,
      waitersFilterModel.code
    );
    if (methods.showApiErrors(resp)) {
      // waitersFilterModel.total = resp.total;
      // waitersFilterModel.parts = methods.calcPageParts(resp.total, waitersFilterModel.size);
      setWaitersFilterModel({ ...waitersFilterModel });
      setAllWaiters(resp.data);
    }
  };

  const showAllDeliveres = (id) => {
    deliverToDeriverModel.invoiceId = id;
    setDeliverToDeriverModel({ ...deliverToDeriverModel });
    getAllDeliveries();
    setShowDeliveryModal(true);
  };

  const showAllWaiters = (id) => {
    deliverToWaiterModel.invoiceId = id;
    setDeliverToDeriverModel({ ...deliverToWaiterModel });
    getAllWaiters();
    setShowWaiterModal(true);
  };

  const searchDelivery = async () => {
    setLoading(true);
    await getAllDeliveries();
    setLoading(false);
  };

  const clearDeliverySearch = async () => {
    setLoading(true);
    resetDeliveryFilters();
    await getAllDeliveries();
    setLoading(false);
  };

  const searchWaiter = async () => {
    setLoading(true);
    await getAllWaiters();
    setLoading(false);
  };

  const clearWaiterSearch = async () => {
    setLoading(true);
    resetWaiterFilters();
    await getAllWaiters();
    setLoading(false);
  };

  const resetDeliveryFilters = () => {
    deliveriesFilterModel.branchId = branchId;
    deliveriesFilterModel.firstName = "";
    deliveriesFilterModel.lastName = "";
    deliveriesFilterModel.mobile = 0;
    deliveriesFilterModel.code = "";
    deliveriesFilterModel.size = 20;
    deliveriesFilterModel.part = 1;
    deliveriesFilterModel.total = 0;
    deliveriesFilterModel.parts = 0;
    setDeliveriesFilterModel({ ...deliveriesFilterModel });
  };

  const resetWaiterFilters = () => {
    waitersFilterModel.branchId = branchId;
    waitersFilterModel.firstName = "";
    waitersFilterModel.lastName = "";
    waitersFilterModel.mobile = "";
    waitersFilterModel.code = "";
    // waitersFilterModel.size = 20;
    // waitersFilterModel.part = 1;
    // waitersFilterModel.total = 0;
    // waitersFilterModel.parts = 0;
    setDeliveriesFilterModel({ ...deliveriesFilterModel });
  };

  const moveDeliveryPagerPart = (isForward) => {
    if (isForward) {
      if (deliveriesFilterModel.parts < deliveriesFilterModel.part + 1) {
        return false;
      }
      callPager(deliveriesFilterModel.part + 1);
    } else {
      if (deliveriesFilterModel.part === 1) {
        return false;
      }
      callPager(deliveriesFilterModel.part - 1);
    }
  };

  const callDeliveryPager = async (i) => {
    setLoading(true);
    deliveriesFilterModel.part = i;
    setDeliveriesFilterModel({ ...deliveriesFilterModel });
    await getAllDeliveries();
    setLoading(false);
  };

  const makeDeliveryPagerItems = () => {
    let pages = [];
    for (let i = 1; i <= deliveriesFilterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            deliveriesFilterModel.part === i
              ? "page-item active mx-1"
              : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callDeliveryPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const selectDriver = async (userId, index) => {
    await resetDeliveryList();
    allDeliveries[index].selected = true;
    setAllDeliveries([...allDeliveries]);
    setDeliverToDeriverModel({
      ...deliverToDeriverModel,
      deliveryUserId: userId,
    });
    setDeliveryOrderToDriverBulkyModel({
      ...deliveryOrderToDriverBulkyModel,
      deliveryUserId: userId,
    });
  };

  const selectWaiter = async (userId, index) => {
    await resetWaiterList();
    allWaiters[index].selected = true;
    setAllWaiters([...allWaiters]);
    deliverToWaiterModel.waiterUserId = userId;
    setDeliverToWaiterModel({ ...deliverToWaiterModel });
  };

  const resetDeliveryList = async () => {
    let item = await allDeliveries.find((x) => x.selected);
    if (item != null || item != undefined) {
      item.selected = false;
      setAllDeliveries([...allDeliveries]);
    }
  };

  const resetWaiterList = async () => {
    let item = await allWaiters.find((x) => x.selected);
    if (item != null || item != undefined) {
      item.selected = false;
      setAllWaiters([...allWaiters]);
    }
  };

  const deliveryToMerchant = async (id) => {
    setLoading(true);
    const deliverToMerchantResp = await apiMethod.deliveryOrderToMerchant(id);
    if (methods.showApiErrors(deliverToMerchantResp)) {
      await getGridData();
    }
    setLoading(false);
  };

  const deliverToDeriver = async () => {
    setLoading(true);
    let deliverToDeriverResp;
    if (deliveryOrderToDriverBulkyModel.invoiceIds.length) {
      deliverToDeriverResp = await apiMethod.deliveryOrderToDriverBulky(
        deliveryOrderToDriverBulkyModel
      );
    } else {
      deliverToDeriverResp = await apiMethod.deliveryOrderToDriver(
        deliverToDeriverModel
      );
    }
    if (methods.showApiErrors(deliverToDeriverResp)) {
      await getGridData();
      setShowDeliveryModal(false);
    }
    setLoading(false);
    resetDeliveryModalState();
  };

  const deliverToWaiter = async () => {
    setLoading(true);
    const deliveryOrderToWaiterResp = await apiMethod.deliveryOrderToWaiter(
      deliverToWaiterModel
    );
    if (methods.showApiErrors(deliveryOrderToWaiterResp)) {
      await getGridData();
      setShowWaiterModal(false);
    }
    setLoading(false);
    resetWaiterModalState();
  };

  const deliveryOrderToOthers = async (invoiceId, shipmentType) => {
    setLoading(true);
    const resp = await apiMethod.deliveryOrderToShipment({
      invoiceId: invoiceId,
      shipmentType: shipmentType,
    });
    if (methods.showApiErrors(resp)) await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.cashDeskId = 0;
    filterModel.orderNumber = 0;
    filterModel.saleUnitId = 0;
    filterModel.categoryId = 0;
    filterModel.orderType = 0;
    filterModel.posDeviceId = 0;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.invoiceNumber = "";
    filterModel.merchantName = "";
    filterModel.merchantPhone = "";
    filterModel.merchantCode = "";
    filterModel.destination = "";
    filterModel.paymentType = 0;
    filterModel.orderStatus = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.endDate = "";
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  // const orderTypeChanged = async (orderType) => {
  //   setLoading(true);
  //   filterModel.orderType = orderType;
  //   setFilterModel({ ...filterModel });
  //   await getGridData();
  //   setLoading(false);
  // };

  const resetDeliveryModalState = () => {
    setAllDeliveries(
      allDeliveries.map((delivery) => ({ ...delivery, selected: false }))
    );
    setDeliverToDeriverModel({ invoiceId: 0, deliveryUserId: "" });
    setDeliveryOrderToDriverBulkyModel({ invoiceIds: [], deliveryUserId: "" });
    setGroupSelection(false);
  };

  const resetWaiterModalState = () => {
    setAllWaiters(allWaiters.map((waiter) => ({ ...waiter, selected: false })));
    setDeliverToWaiterModel({ invoiceId: 0, waiterUserId: "" });
  };

  const generateShipmentAction = (itemId, shipmentType) => {
    return (
      <>
        {shipmentType === 1 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => deliveryToMerchant(itemId)}
          >
            تحویل به مشتری
          </button>
        )}
        {shipmentType === 2 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => showAllDeliveres(itemId)}
          >
            تحویل به پیک شعبه
          </button>
        )}
        {shipmentType === 3 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => deliveryOrderToOthers(itemId, 3)}
          >
            تحویل به پیک اسنپ
          </button>
        )}
        {shipmentType === 4 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => deliveryOrderToOthers(itemId, 4)}
          >
            تحویل به پیک میاره
          </button>
        )}
        {shipmentType === 5 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => deliveryOrderToOthers(itemId, 5)}
          >
            تحویل به دیجی اکسپرس
          </button>
        )}
        {shipmentType === 6 && (
          <button
            type="button"
            className="btn custome-btn btn-purple w-100"
            style={{ fontSize: "12px" }}
            onClick={() => showAllWaiters(itemId)}
          >
            تحویل به گارسون
          </button>
        )}
      </>
    );
  };

  const URL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveNewOrderPanel", (bid, orderId, status) => {
      if (status === 2) getGridData();
    });
  };

  const getBaseInfo = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);

    const resp2 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp2)) setUnits(resp2.data);
  };

  const handleChangeItem = (e) => {
    const { value, checked } = e.target;

    setDeliveryOrderToDriverBulkyModel((prev) => ({
      ...prev,
      invoiceIds: checked
        ? [...prev.invoiceIds, value]
        : prev.invoiceIds.filter((id) => id !== value),
    }));
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleDetail = (id) => {
    setDetailItem(id);
    setShowDetailModal(true);
  };

  const detailFiltered = gridData.find((item) => item.id === detailItem);

  const moduleBinder = () => {
    return (
      <div className="p-lg-4 mx-auto">
        {loading && <Preloading></Preloading>}
        {
          <div className="row bg-light">
            <div
              className={`col-12 ${
                collapsed ? "col-lg-1" : "col-lg-2"
              } border-end border-secondary-subtle p-0 bg-white`}
            >
              <div className="d-flex justify-content-end pt-4">
                <span className="toggleImg" onClick={toggleSidebar}>
                  {collapsed ? (
                    <i className="bi bi-arrow-left-circle fs-5"></i>
                  ) : (
                    <i className="bi bi-arrow-right-circle fs-5"></i>
                  )}
                </span>
              </div>
              <div className="d-flex flex-column gap-3 px-4 mt-5">
                <button
                  className="btn btn-purple"
                  style={{ fontSize: collapsed ? "12px" : "16px" }}
                >
                  لیست سفارشات
                </button>
                <Link
                  to={`/shipping/${branchId}/archive-delivery`}
                  className="w-100"
                >
                  <button
                    className="btn btn-outline-purple w-100"
                    style={{ fontSize: collapsed ? "12px" : "16px" }}
                  >
                    آرشیو لیست سفارشات
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-12 col-lg-10">
              <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
                <div>
                  <Link to={`/sale/${branchId}/#1`} className="link back-link">
                    <span>
                      <img src={back} className="" alt="return" />
                    </span>
                  </Link>
                  تحویل سفارش
                </div>
                <p className="date">{methods.currentDate()}</p>
              </div>
              <div className="saleheader d-none d-lg-block">
                <p>تحویل سفارش</p>
              </div>
              <div className="salemain">
                <div className="salesearchsection">
                  <div className="row g-3">
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        نام
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.merchantName}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            merchantName: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره سفارش
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.orderNumber}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            orderNumber: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره فاکتور
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.invoiceNumber}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            invoiceNumber: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                    {/* <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره فیش
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.orderNumber}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            orderNumber: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div> */}
                    <div className="col-12 col-md-2">
                      <label htmlFor="funit" className="form-label">
                        شماره اشتراک
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.merchantCode}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            merchantCode: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>

                    <div className="col-12 col-md-2">
                      <label htmlFor="filters" className="form-label">
                        نوع سفارش
                      </label>
                      <select
                        id="filters"
                        className="form-select"
                        aria-label="menu"
                        value={filterModel.orderType}
                        onChange={(e) => {
                          filterModel.orderType = e.target.value;
                          setFilterModel({ ...filterModel });
                        }}
                      >
                        <option value={0}>همه</option>
                        {orderTypes.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="ddlStatuses" className="form-label">
                        بخش های فروش
                      </label>
                      <select
                        id="ddlStatuses"
                        className="form-select"
                        aria-label="menu"
                        value={filterModel.saleUnitId}
                        onChange={(e) => {
                          filterModel.saleUnitId = e.target.value;
                          setFilterModel({ ...filterModel });
                        }}
                      >
                        <option value={0}>همه بخش ها</option>
                        {units.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="enddate" className="form-label">
                        از تاریخ
                      </label>
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-center"
                        format="YYYY/MM/DD"
                        value={filterModel.startDate}
                        onChange={(value) => {
                          if (value)
                            filterModel.startDate = value.format("YYYY/MM/DD");
                          else filterModel.startDate = "";
                          setFilterModel({ ...filterModel });
                        }}
                        inputClass="form-control"
                        containerStyle={{
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                      <label htmlFor="enddate" className="form-label">
                        تا تاریخ
                      </label>
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-center"
                        format="YYYY/MM/DD"
                        value={filterModel.endDate}
                        onChange={(value) => {
                          if (value)
                            filterModel.endDate = value.format("YYYY/MM/DD");
                          else filterModel.endDate = "";
                          setFilterModel({ ...filterModel });
                        }}
                        inputClass="form-control"
                        containerStyle={{
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-2 d-flex align-items-end">
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                    <div className="col-12 col-md-2 text-end d-flex align-items-end justify-content-end mt-4">
                      {deliveryOrderToDriverBulkyModel &&
                      deliveryOrderToDriverBulkyModel?.invoiceIds.length > 1 ? (
                        <button
                          className="btn btn-purple w-100"
                          onClick={() => {
                            getAllDeliveries();
                            setShowDeliveryModal(true);
                          }}
                        >
                          تحویل به پیک
                        </button>
                      ) : (
                        <button
                          className="btn text-white w-100"
                          style={{ background: "#342947" }}
                          onClick={() => setGroupSelection((prev) => !prev)}
                        >
                          انتخاب گروهی
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="saletable">
                <div className="row">
                  {gridData.map((item, index) => (
                    <div
                      className="tab-pane fade show col-12 col-md-6 col-xxl-4 active"
                      id={`${item.id}`}
                      key={index}
                    >
                      <div className="card mb-3">
                        <div className="card-body">
                          {groupSelection && (
                            <div className="form-check checkbox-delivery">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={item.id}
                                id={`checkbox-${item.id}`}
                                onChange={handleChangeItem}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`checkbox-${item.id}`}
                              >
                                انتخاب کنید
                              </label>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-4 col-xxl-4 d-flex mb-3 fs-14">
                              <span>
                                {methods.toPersianDate(
                                  item.createDate,
                                  "jYYYY/jMM/jDD"
                                )}
                              </span>
                            </div>
                            <div className="col-4 col-xxl-4 d-flex justify-content-center mb-3 fs-14">
                              <span style={{ fontWeight: "bold" }}>
                                {item.merchantName}
                              </span>
                            </div>
                            <div className="col-4 col-xxl-4 d-flex justify-content-end mb-3 fs-14">
                              <span className="badge sidebar-badge rounded-pill ms-2">
                                {
                                  orderTypes.find(
                                    (orderType) =>
                                      orderType.id === item.orderType
                                  )?.title
                                }
                              </span>
                            </div>
                            <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                              <span>اشتراک : {item.merchantCode}</span>
                            </div>
                            <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                              <span>شماره فاکتور : {item.invoiceNumber}</span>
                            </div>
                            <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                              <span>شماره سفارش : {item.orderNumber}</span>
                            </div>
                            <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                              <span>موبایل : {item.merchantPhone}</span>
                            </div>
                            <div className="col-6 col-xxl-4 d-flex mb-3 fs-14">
                              <span>
                                {methods.toPersianDate(
                                  item.createDate,
                                  " ساعت: HH:mm"
                                )}
                              </span>
                            </div>
                            <div className="col-12 d-flex mb-3 fs-14">
                              <span className="text-justify fs-14">
                                آدرس:{" "}
                                <span className="break-text">
                                  {item.destination}
                                </span>
                              </span>
                            </div>
                          </div>
                          {item.shipmentType ? (
                            <div className="row">
                              <div className="col-6">
                                <button
                                  className="btn btn-outline-purple w-100"
                                  style={{ height: "48px", fontSize: "12px" }}
                                  onClick={() => handleDetail(item.id)}
                                >
                                  جزییات
                                </button>
                              </div>
                              <div className="col-6">
                                {generateShipmentAction(
                                  item.id,
                                  item.shipmentType
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="w-100">
                              <button
                                className="btn btn-outline-purple w-100"
                                style={{ height: "48px", fontSize: "12px" }}
                                onClick={() => handleDetail(item.id)}
                              >
                                جزییات
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  {filterModel.parts > 1 && (
                    <div className="pagination justify-content-center mt-5">
                      <Paginations
                        total={filterModel.total}
                        size={filterModel.size}
                        onPageChange={callPager}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  };

  const DeliveryModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showDeliveryModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص پیک</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowDeliveryModal(false);
                  resetDeliveryModalState();
                  resetDeliveryFilters();
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-1">
                <div className="col-12 col-md-3">
                  <label htmlFor="funit" className="form-label">
                    نام
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={deliveriesFilterModel.firstName}
                    onChange={(e) => {
                      setDeliveriesFilterModel({
                        ...deliveriesFilterModel,
                        firstName: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="funit" className="form-label">
                    نام‌خانوادگی
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={deliveriesFilterModel.lastName}
                    onChange={(e) => {
                      setDeliveriesFilterModel({
                        ...deliveriesFilterModel,
                        lastName: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="fstatus" className="form-label">
                    کد پرسنلی
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={deliveriesFilterModel.code}
                    onChange={(e) => {
                      setDeliveriesFilterModel({
                        ...deliveriesFilterModel,
                        code: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3" style={{ marginTop: "37px" }}>
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={() => {
                      searchDelivery();
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearDeliverySearch}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive saletable text-start">
                <table className="table table-hovered table-sm align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center">ردیف</th>
                      <th scope="col vertical-center"> نام پیک</th>
                      <th scope="col vertical-center">شماره موبایل پیک</th>
                      <th scope="col vertical-center">کد پرسنلی</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {allDeliveries.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row ">{index + 1}</td>
                        <td
                          className={`${
                            item.selected ? "selectedDelivery" : ""
                          }`}
                        >
                          <div className="d-inline-flex align-content-center justify-content-center ">
                            <input
                              checked={!!item.selected}
                              onChange={() => {
                                selectDriver(item.userId, index);
                              }}
                              type="checkbox"
                              className="form-check-input deliveryCheckbox"
                            />
                            {item.firstname} {""} {item.lastname}
                          </div>
                        </td>
                        <td>{item.phoneNumber}</td>
                        <td>{item.employeeCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {deliveriesFilterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPagesWaiter}
                      size={deliveriesFilterModel.size}
                      onPageChange={callDeliveryPager}
                    />
                  </div>
                )}
              </div>
              <div className="text-end mt-3">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple"
                  onClick={() => {
                    setShowDeliveryModal(false);
                    resetDeliveryModalState();
                    resetDeliveryFilters();
                  }}
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  className="btn custome-btn btn-purple ms-2"
                  onClick={() => {
                    deliverToDeriver();
                  }}
                  disabled={!deliverToDeriverModel.deliveryUserId}
                >
                  تحویل به پیک
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const WaiterModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showWaiterModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص گارسون</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowWaiterModal(false);
                  resetWaiterModalState();
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-1">
                <div className="col-12 col-md-3">
                  <label htmlFor="funit" className="form-label">
                    نام
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={waitersFilterModel.firstName}
                    onChange={(e) => {
                      setWaitersFilterModel({
                        ...waitersFilterModel,
                        firstName: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="funit" className="form-label">
                    نام‌خانوادگی
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={waitersFilterModel.lastName}
                    onChange={(e) => {
                      setWaitersFilterModel({
                        ...waitersFilterModel,
                        lastName: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="fstatus" className="form-label">
                    کد پرسنلی
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={waitersFilterModel.code}
                    onChange={(e) => {
                      setWaitersFilterModel({
                        ...waitersFilterModel,
                        code: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-3" style={{ marginTop: "37px" }}>
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={() => {
                      searchWaiter();
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearWaiterSearch}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive saletable text-start">
                <table className="table table-hovered table-sm align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center">ردیف</th>
                      <th scope="col vertical-center"> نام گارسون</th>
                      <th scope="col vertical-center">شماره موبایل گارسون</th>
                      <th scope="col vertical-center">کد پرسنلی</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {allWaiters.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row ">{index + 1}</td>
                        <td
                          className={`${
                            item.selected ? "selectedDelivery" : ""
                          }`}
                        >
                          <div className="d-inline-flex align-content-center justify-content-center ">
                            <input
                              checked={!!item.selected}
                              onChange={() => {
                                selectWaiter(item.userId, index);
                              }}
                              type="checkbox"
                              className="form-check-input deliveryCheckbox"
                            />
                            {item.firstname} {""} {item.lastname}
                          </div>
                        </td>
                        <td>{item.phoneNumber}</td>
                        <td>{item.employeeCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* {waitersFilterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { moveDeliveryPagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makeDeliveryPagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { moveDeliveryPagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                } */}
              </div>
              <div className="text-end mt-3">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple"
                  onClick={() => {
                    setShowWaiterModal(false);
                    resetWaiterModalState();
                  }}
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  className="btn custome-btn btn-purple ms-2"
                  disabled={!deliverToWaiterModel.waiterUserId}
                  onClick={() => {
                    deliverToWaiter();
                  }}
                >
                  تحویل به گارسون
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  console.log({'detailFiltered:::' : detailFiltered})

  const DetailModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showDetailModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">جزییات سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowDetailModal(false);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                <span>نام مشتری : </span>
                <span style={{ fontWeight: "bold" }}>
                  {detailFiltered?.merchantName}
                </span>
                </div>
                <div className="d-flex align-items-center gap-2">
                <span>شماره :</span>
                <span style={{ fontWeight: "bold" }}>
                  {detailFiltered?.merchantPhone}
                </span>
                </div>
                <div className="d-flex align-items-center gap-2">
                <span>شماره سفارش:</span>
                <span style={{ fontWeight: "bold" }}>
                  {detailFiltered?.orderNumber}
                </span>
                </div>
              </div>
              <div className="table-responsive text-center mt-3">
                <table className="table table-bordered table-sm align-middle">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center">ردیف</th>
                      <th scope="col vertical-center">تعداد</th>
                      <th scope="col vertical-center">نام کالا</th>
                      <th scope="col vertical-center">قیمت</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {detailFiltered?.invoiceItems?.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row ">{index + 1}</td>
                        <td>{item.amount}</td>
                        <td>{item.productName}</td>
                        <td>{methods.addNumSeperator(item.finalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="align-middle">
                    <tr className="fw-bold bg-light">
                      <td colSpan="3" className="text-end">
                        جمع کل:
                      </td>
                      <td>{methods.addNumSeperator(detailFiltered?.totalFinalPrice)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="row">
                {detailFiltered?.shipmentType &&
                [1, 2, 3, 4, 5, 6].includes(detailFiltered.shipmentType) ? (
                  <>
                    <div className="col-6">
                      <button
                        className="btn btn-outline-purple w-100"
                        style={{ height: "48px" }}
                        onClick={() => setShowDetailModal(false)}
                      >
                        بستن
                      </button>
                    </div>
                    <div className="col-6">
                      {generateShipmentAction(
                        detailFiltered?.id,
                        detailFiltered?.shipmentType
                      )}
                    </div>
                  </>
                ) : (
                  <div className="col-12">
                    <button
                      className="btn btn-outline-purple w-100"
                      style={{ height: "48px" }}
                      onClick={() => setShowDetailModal(false)}
                    >
                      بستن
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {moduleBinder()}
      {showDeliveryModal && DeliveryModal()}
      {showWaiterModal && WaiterModal()}
      {DetailModal && DetailModal()}
    </>
  );
};

export default ShippingDelivery;
